import { ParsedUrlQuery } from "querystring";

const DEFAULT_EXCLUDED_QUERY_KEYS = new Set(["path", "sp-pdp-schema-variant"]);

export function filterQueryParams(
  query: ParsedUrlQuery,
  keysToExclude: string[] = [],
): ParsedUrlQuery {
  const excludedKeys = new Set([
    ...DEFAULT_EXCLUDED_QUERY_KEYS,
    ...keysToExclude,
  ]);

  return Object.entries(query).reduce<ParsedUrlQuery>((acc, [key, val]) => {
    if (
      excludedKeys.has(key) ||
      val === undefined ||
      val === null ||
      val === ""
    ) {
      return acc;
    }
    return { ...acc, [key]: val };
  }, {});
}
